import { takeLatest, call, put, select } from "redux-saga/effects";
import * as types from "src/types/actions";
import { athenaCallApi } from "./helpers";
import callApi from "./helpers";
import { athenaURL, apiGraphQLURI, apiURI } from "../env";

const getGraphQLConfig = (params, query) => {
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${params.payload.token}`,
    },
    mode: "cors",
    method: "POST",
    body: JSON.stringify(query),
  };
};

export function* athenaAuth(action) {
  try {
    const res1 = yield fetch(`${athenaURL}/login`, {
      headers: {
        "Content-Type": "application/json",
      },
      mode: "cors",
      method: "POST",
      // credentials: "include",
      body: JSON.stringify(action.payload),
    });

    const authorization = res1.headers.get("Exposed-Cookie").split(";")[0].split("=")[1];

    if (res1.ok) {
      const data1 = yield res1.json();
      yield put({
        type: types.ATHENA_AUTH_SUCCESS,
        response: { shift: data1, authorization },
      });
    }
  } catch (error) {
    const errorMessage = error?.message || "An error occurred during authentication";
    yield put({
      type: types.ATHENA_AUTH_FAILURE,
      error: { message: errorMessage },
    });

    // Optionally create a toast with the error message
    yield put({
      type: types.CREATE_TOAST,
      payload: { type: "error", message: "Failed to login" },
    });
  }
}

export function* athenaVirAuth(action) {
  // const sessionId = yield select((state) => state.vir.athenaAuth.thermeon.data.SessionID);
  const authorization = yield select((state) => state.vir.athenaAuth.authorization);
  yield call(
    athenaCallApi,
    () =>
      fetch(`${athenaURL}/vir/login`, {
        headers: {
          "Content-Type": "application/json",
          // "X-Thermeon-SessionId": sessionId,
          Authorization: `Bearer ${authorization}`,
        },
        mode: "cors",
        method: "POST",
        body: JSON.stringify(action.payload),
      }),
    action.type
  );
}
export function* athenaVirUser(action) {
  const authorization = yield select((state) => state.vir.athenaAuth.authorization);
  yield call(
    athenaCallApi,
    () =>
      fetch(`${athenaURL}/vir/user`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authorization}`,
        },
        mode: "cors",
        method: "POST",
        body: JSON.stringify(action.payload),
      }),
    action.type
  );
}

// for servicetracking
export function* athenaVirServiceTracking(action) {
  const authorization = yield select((state) => state.vir.athenaAuth.authorization);
  yield call(
    athenaCallApi,
    () =>
      fetch(`${athenaURL}/vir/serviceTracking/virs`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authorization}`,
        },
        mode: "cors",
        method: "POST",
        body: JSON.stringify(action.payload),
      }),
    action.type
  );
}

export function* searchAddress(params) {
  console.log("params for address", params);
  const updateQuery = {
    query: ` query {
      KleberDataValidation(
        Address: "${params.payload.address}",
        CountryCode : "${params.payload.countryCode}"
        Method:"${params.payload.method}",

      ){
        Success,
        Error,
        Status,
        International,
        SuggestionCountry,
        AddressResult{
          RecordId
          AddressLine,
          State,
          Locality,
          Postcode,
          Suburb,
          TownCityMailtown
          }
        }
      }   
  `,
  };
  yield call(
    callApi,
    () => fetch(apiGraphQLURI, getGraphQLConfig(params, updateQuery)),
    types.SEARCHADDRESS,
    { ...params.payload }
  );
}

export function* retrieveAddress(params) {
  const updateQuery = {
    query: ` query {
      KleberDataValidation(
        RecordId: "${params.payload.recordId}",
        Method:"${params.payload.method}",
        CountryCode: "${params.payload.countryCode}",
      ){
        Success,
        Error,
        Status,
        SuggestionCountry,
        AddressResult{
          AddressLine,
          State,
          Locality,
          Postcode,
          Suburb,
          AddressLine1,
          AddressLine2,
          LocalityCityTown,
          TownCityMailtown,
          StateProvince,
          District,
          }
        }
      }   
  `,
  };
  yield call(
    callApi,
    () => fetch(apiGraphQLURI, getGraphQLConfig(params, updateQuery)),
    types.RETRIEVEADDRESS,
    { ...params.payload }
  );
}

//for individual vir detail data
export function* athenaVirDetail(action) {
  const authorization = yield select((state) => state.vir.athenaAuth.authorization);
  yield call(
    athenaCallApi,
    () =>
      fetch(`${athenaURL}/vir/detail`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authorization}`,
        },
        mode: "cors",
        method: "POST",
        body: JSON.stringify(action.payload),
      }),
    action.type
  );
}
//for individual vir initialize data
// export function* athenaVirInitialize(action) {
//   const authorization = yield select((state) => state.vir.athenaAuth.authorization);
//   console.log("data to intialize", action.payload);
//   yield call(
//     athenaCallApi,
//     () =>
//       fetch(`${athenaURL}/vir/init`, {
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${authorization}`,
//         },
//         mode: "cors",
//         method: "POST",
//         body: JSON.stringify(action.payload),
//       }),
//     action.type
//   );
// }

export function* athenaVirDetailPatch(action) {
  const authorization = yield select((state) => state.vir.athenaAuth.authorization);
  try {
    const response = yield call(() =>
      fetch(`${athenaURL}/vir/detail`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authorization}`,
        },
        mode: "cors",
        method: "PATCH",
        body: JSON.stringify(action.payload),
      })
    );

    const responseData = yield response.json();

    if (response.ok && responseData?.message) {
      yield put({ type: types.ATHENA_VIR_DETAIL_PATCH_SUCCESS, payload: responseData });
    } else {
      throw new Error(responseData?.message || "Failed to update VIR");
    }
  } catch (error) {
    yield put({
      type: types.ATHENA_VIR_DETAIL_PATCH_FAILURE,
      message: "Failed to update, please check network",
    });
  }
}
// // for damage images  file
export function* athenaDamagePresigned(action) {
  const authorization = yield select((state) => state.vir.athenaAuth.authorization);
  console.log("data to presigned", action.payload);
  const queryString = Object.entries(action.payload)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join("&");
  console.log("query data load", queryString);
  console.log("type --", action.type);
  yield call(
    athenaCallApi,
    () =>
      fetch(`${athenaURL}/wecapture/get_presigned_url?${queryString}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authorization}`,
        },
        mode: "cors",
        method: "GET",
      }),

    action.type
  );
}

// // for damage zip photos  file
export function* athenaDamagePhotoZip(action) {
  console.log("check payload", action.payload);
  const resDamage = yield select((state) => state.vir.athenaDamagePresigned.data);
  console.log("print damage".resDamage);
  // const keyValuePairs = resDamage.split("&");
  // const parsedData = keyValuePairs.reduce((acc, pair) => {
  //   const [key, value] = pair.split("="); // Split by `=`
  //   acc[key] = value; // Add key-value to the accumulator object
  //   return acc;
  // }, {});
  // console.log("resDamage response", parsedData);
  yield call(
    athenaCallApi,
    () =>
      fetch(resDamage, {
        mode: "cors",
        method: "PUT",
        body: action.payload.Body,
      }),
    action.type
  );
}

// for create form
export function* athenaVirCreate(action) {
  const authorization = yield select((state) => state.vir.athenaAuth.authorization);
  try {
    const response = yield call(() =>
      fetch(`${athenaURL}/vir/create`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authorization}`,
        },
        mode: "cors",
        method: "POST",
        body: JSON.stringify(action.payload),
      })
    );

    const responseData = yield response.json();

    if (response.ok && responseData?.message) {
      yield put({ type: types.ATHENA_VIR_CREATE_SUCCESS, payload: responseData });
    } else {
      throw new Error(responseData?.message || "Failed to create VIR");
    }
  } catch (error) {
    yield put({ type: types.ATHENA_VIR_CREATE_FAILURE, error });
  }
}

// for create form
export function* virSendContact(action) {
  try {
    const payload = {
      virId: action.payload.virId,
      rentalAgreementNumber: action.payload.rentalAgreementNumber,
      reservationNumber: action.payload.reservationNumber,
      firstName: action.payload.firstName,
      lastName: action.payload.lastName,
      email: action.payload.email,
      contactNumber: action.payload.contactNumber,
      enquiryType: action.payload.enquiryType,
      enquiryDetails: action.payload.enquiryDetails,
      brand: action.payload.brand,
    };
    const response = yield call(() =>
      fetch(`${apiURI}/vir/contact-us`, {
        headers: {
          "Content-Type": "application/json",
        },
        mode: "cors",
        method: "POST",
        body: JSON.stringify(payload),
      })
    );

    const responseData = yield response.json();

    if (response.ok && responseData?.message) {
      yield put({ type: types.VIR_SEND_CONTACT_SUCCESS, payload: responseData });
    } else {
      throw new Error(
        responseData?.errors[0] || "Failed to send VIR request. Please use another contact method"
      );
    }
  } catch (error) {
    yield put({
      type: types.CREATE_TOAST,
      payload: { type: "error", message: error.message },
    });
    yield put({ type: types.VIR_SEND_CONTACT_FAILURE, error });
  }
}

export function* watchVirRequest() {
  yield takeLatest(types.ATHENA_AUTH, athenaAuth);
  yield takeLatest(types.ATHENA_VIR_AUTH, athenaVirAuth);
  yield takeLatest(types.ATHENA_VIR_USER, athenaVirUser);
  yield takeLatest(types.SEARCHADDRESS, searchAddress);
  yield takeLatest(types.RETRIEVEADDRESS, retrieveAddress);
  yield takeLatest(types.ATHENA_VIR_SERVICETRACKING, athenaVirServiceTracking);
  yield takeLatest(types.ATHENA_VIR_DETAIL, athenaVirDetail);
  yield takeLatest(types.ATHENA_VIR_DETAIL_PATCH, athenaVirDetailPatch);
  // yield takeLatest(types.ATHENA_VIR_INTIALIZE, athenaVirInitialize);
  yield takeLatest(types.ATHENA_DAMAGE_PRESIGNED, athenaDamagePresigned);
  yield takeLatest(types.ATHENA_DAMAGE_PHOTO_ZIP, athenaDamagePhotoZip);
  yield takeLatest(types.ATHENA_VIR_CREATE, athenaVirCreate);
  yield takeLatest(types.VIR_SEND_CONTACT, virSendContact);
}
